import { get } from "lodash";
import styled from "styled-components/macro";
import { TextField as MuiTextField } from "@mui/material";
import { store } from "../redux/store";
import { setActionDispatch } from "../redux/slices/renderUISlice";

function select(state) {
  return state.renderUIDetails;
}

let currentValue;
let TextFieldWithCSS = styled(MuiTextField)``;

function handleChange() {
  currentValue = select(store.getState());

  if (currentValue.actionDispatch === "done") {
    TextFieldWithCSS = styled(MuiTextField)`
      & label.Mui-focused {
        color: #949494;
      }

      & .MuiOutlinedInput-root {
        &.Mui-focused fieldset {
          border-color: #949494;
        }
      }

      .MuiInputLabel-root {
        color: #333;
      }

      .MuiOutlinedInput-notchedOutline {
        border-radius: 12px;
      }

      .MuiOutlinedInput-root {
        font-size: 16px;
        border-color: #949494;
        border-radius: 12px;
      }

      .Mui-disabled {
        color: rgba(0, 0, 0, 0.66);
        font-size: 16px;
        border-radius: 12px;
        -webkit-text-fill-color: rgba(0, 0, 0, 0.66);
      }

      .MuiInputLabel-outlined {
        font-size: 16px;
      }

      .Mui-disabled .MuiOutlinedInput-notchedOutline {
        border-color: #f5f5f5;
        border: 1px solid #c4cacb;
      }

      #mui-7-helper-text {
        color: red;
      }
      .MuiInputLabel-asterisk {
        color: ${(props) =>
          Boolean(props.required && !props.value) ? "red" : ""};
      }
    `;

    store.dispatch(setActionDispatch(""));
  }
}

store.subscribe(handleChange);

export default function TextField({ formikProps, ...props }) {
  if (!!formikProps) {
    function handleTouch() {
      if (Object.keys(formikProps?.touched).length > 0) {
        for (let field in formikProps.touched) {
          if (field !== props.name) {
            formikProps.setTouched({
              ...formikProps.touched,
              [props.name]: true,
            });
          } else {
            formikProps.setTouched({ [props.name]: true });
          }
        }
      } else {
        formikProps.setTouched({ [props.name]: true });
      }
    }

    return (
      <TextFieldWithCSS
        size="small"
        onClick={handleTouch}
        onChange={formikProps.handleChange}
        inputProps={{
          "aria-label": "Without label",
        }}
        error={
          get(formikProps.touched, props.name) && props.select
            ? Boolean(
                !get(formikProps.values, props.name) &&
                  get(formikProps.errors, props.name)
              )
            : !!get(formikProps.touched, props.name) &&
              get(formikProps.errors, props.name)
        }
        helperText={
          get(formikProps.touched, props.name) && props.select
            ? !get(formikProps.values, props.name) &&
              get(formikProps.errors, props.name)
            : !!get(formikProps.touched, props.name) &&
              get(formikProps.errors, props.name)
        }
        onBlur={formikProps.handleBlur}
        value={get(formikProps.values, props.name, "")}
        fullWidth
        variant="outlined"
        {...props}
      />
    );
  }

  return <TextFieldWithCSS variant="outlined" fullWidth {...props} />;
}
